export default __webpack_public_path__ + "static/media/payoff-rocket.82e9690f.png";